module.exports = __webpack_public_path__ + "img/honor_003.8ae4003.webp";